import { Menu as MenuPrimitive } from '@base-ui/react/menu';

import CheckIcon from '@/assets/svg/bx-check.svg?react';
import { cn } from '@/lib/utils';

export type DropdownMenuRadioItemProps = MenuPrimitive.RadioItem.Props & {
  inset?: boolean;
};

const DropdownMenuRadioItem = ({
  className,
  children,
  inset,
  ...props
}: DropdownMenuRadioItemProps) => {
  return (
    <MenuPrimitive.RadioItem
      data-slot="dropdown-menu-radio-item"
      data-inset={inset}
      className={cn(
        'relative flex items-center gap-1.5 outline-hidden',
        'rounded-md py-1 pr-8 pl-1.5 text-sm',
        'cursor-pointer select-none data-inset:pl-7',
        "[&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",

        'focus:bg-primary focus:text-gray-900 focus:**:text-gray-900',

        'data-disabled:cursor-not-allowed data-disabled:bg-white! data-disabled:text-gray-500 data-disabled:*:[svg]:text-gray-500',
        className,
      )}
      {...props}
    >
      <span
        className="pointer-events-none absolute right-2 flex items-center justify-center"
        data-slot="dropdown-menu-radio-item-indicator"
      >
        <MenuPrimitive.RadioItemIndicator>
          <CheckIcon className="-mr-1 size-5" />
        </MenuPrimitive.RadioItemIndicator>
      </span>
      {children}
    </MenuPrimitive.RadioItem>
  );
};

export default DropdownMenuRadioItem;
